/** Dashboard Component */

import { get, isEmpty } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import { Paper } from '@mui/material';
import QuickLinks from './QuickLinks';
import Page from '../Page/index.ts';
import Header from '../Header/index.ts';

const useStyles = makeStyles()((theme) => ({
  root: {
    flex: '1',
    flexDirection: 'column',
    padding: '15px',
  },
  paper: {
    borderRadius: '4px',
    margin: '15px',
    padding: '35px',
  },
  messages: {
    background: get(theme, `palette.bg.main`),
    borderRadius: '12px',
    minHeight: '150px',
    '& h6': {
      margin: '0px',
      marginBottom: '7px',
    },
    '& p': {
      fontSize: '14px',
    },
  },
}));

export default function Dashboard(props) {
  const { classes, cx } = useStyles();
  const { vendor, location } = props;
  const userId = location.pathname.split('/')[2];

  if (!vendor || isEmpty(vendor)) return null;

  return (
    <Page.Container>
      <Header.Major icon="grid/grid-dashboard-02" title="Dashboard" />
      <Page.Content>
        <Paper elevation={15} className={cx(classes.paper, classes.messages)}>
          <h6>MESSAGES</h6>
          <p>{vendor.portal_message}</p>
        </Paper>
        <QuickLinks vendor={vendor} userId={userId} />
      </Page.Content>
    </Page.Container>
  );
}

Dashboard.propTypes = {
  vendor: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};
